const stringToColor = (string: string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

export const getAvatarInitials = (name: string) => {
  const initials = name.split(' ');

  return {
    color: stringToColor(name),
    initials: `${initials && initials[0] ? initials[0][0] : ' '}${
      initials && initials[1] ? initials[1][0] : ''
    }`.toUpperCase(),
  };
};

export const stringAvatar = (name: string) => {
  const { color, initials } = getAvatarInitials(name);

  return {
    sx: {
      bgcolor: color,
    },
    children: initials,
  };
};
